import { type SVGProps } from 'react';

export const Google = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 48 48"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12v-8c-11 0-20 9-20 20s9 20 20 20z"
        fill="#fbc02d"
      />
      <path
        d="m6.31 14.7 6.57 4.82c1.78-4.4 6.08-7.51 11.1-7.51 3.06 0 5.84 1.15 7.96 3.04l5.66-5.66c-3.57-3.33-8.35-5.38-13.6-5.38-7.68 0-14.3 4.34-17.7 10.7z"
        fill="#e53935"
      />
      <path
        d="m24 44c5.17 0 9.86-1.98 13.4-5.19l-6.19-5.24a11.9 11.9 0 01-7.22 2.43c-5.2 0-9.62-3.32-11.3-7.95l-6.52 5.02c3.31 6.48 10 10.9 17.8 10.9z"
        fill="#4caf50"
      />
      <path
        d="m43.6 20.1-.016-.083h-19.6v8h11.3a12 12 0 01-4.09 5.57l.003-.002 6.19 5.24c-.438.398 6.59-4.81 6.59-14.8 0-1.34-.138-2.65-.389-3.92z"
        fill="#1565c0"
      />
    </svg>
  );
};
